export default "__VITE_ASSET__69102057__"